var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttributesOverridesGreenToggled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.9895C0.00274507 1.59557 0.16035 1.21853 0.438769 0.939826C0.717188 0.661127 1.09407 0.503142 1.488 0.5H28.512C29.334 0.5 30 1.1675 30 1.9895V26.0105C29.9973 26.4044 29.8396 26.7815 29.5612 27.0602C29.2828 27.3389 28.9059 27.4969 28.512 27.5H1.488C1.09322 27.4996 0.714745 27.3425 0.435734 27.0632C0.156723 26.7839 -2.00183e-07 26.4053 0 26.0105V1.9895ZM9 3.5V24.5H21V3.5H9ZM3 3.5V6.5H6V3.5H3ZM24 3.5V6.5H27V3.5H24ZM3 9.5V12.5H6V9.5H3ZM24 9.5V12.5H27V9.5H24ZM3 15.5V18.5H6V15.5H3ZM24 15.5V18.5H27V15.5H24ZM3 21.5V24.5H6V21.5H3ZM24 21.5V24.5H27V21.5H24Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttributesOverridesGreenToggled);
export default __webpack_public_path__ + "static/media/Attributes-Overrides-Green-Toggled.e838d0ffee0c7425477ffc675becfd61.svg";
export { ForwardRef as ReactComponent };